<div class="table-container">
  <div class="data-card">
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" matSort>

        <!-- Role Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
          <td mat-cell *matCellDef="let row"> {{row.description}} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let row">
            <div class="actions">
              <button matButton class="act-btn" (click)="onEditRole(row)" matTooltip="Edit Role">
                <i class="fa-solid fa-pen"></i>
              </button>
              <button matButton class="act-btn danger" (click)="onDeleteRole(row)" matTooltip="Delete Role">
                <i class="fa-regular fa-trash-can"></i>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      aria-label="Select page">
    </mat-paginator>
  </div>

  <button class="fab fab-left" (click)="onNewRole()">
    <i class="fa-solid fa-plus"></i>
    New Role
  </button>

</div>
